export default __webpack_public_path__ + "static/media/election2016primary.c0ae36cd.txt";